export default "https://cdn-static.gokick.com/assets/37f77ff38331b66adda42c842f0b505f9084d1fd/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";